import { Link } from '@on3/ui-lib/components/Link';
import { SocialIcon } from '@on3/ui-lib/components/SocialIcon';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { FanSiteAvatar } from 'components/Image/FanSiteAvatar';
import { SideModuleWrapper } from 'components/UI/Layout/Containers/Sidebar/SideModuleWrapper';
import { useMemo } from 'react';
import { createTitle } from 'utils/meta';

import styles from './Connect.module.scss';

export const TeamConnect = () => {
  const { currentSite } = useSite();
  const siteBackground = useMemo(
    () => ({ backgroundColor: currentSite?.primaryColor || '#010101' }),
    [currentSite?.primaryColor],
  );
  const twitter = currentSite?.twitterHandle;
  const instagram = currentSite?.instagramProfile;
  const facebook = currentSite?.facebookProfile;
  const youtube = currentSite?.youtubeProfile;
  const tiktok =
    (currentSite as any)?.tiktokProfile || // @TODO: Fix type for tiktokProfile
    ([24, 395].includes(currentSite?.key) && 'kentuckysportsradio');
  const noProfiles = !twitter && !instagram && !facebook && !youtube && !tiktok;

  const title = createTitle(
    currentSite?.siteName || currentSite?.name,
    'Connect',
  );

  if (noProfiles) {
    return null;
  }

  return (
    <SideModuleWrapper title={title}>
      <div className={styles.social}>
        <span className={styles.sitelogo} style={siteBackground}>
          <FanSiteAvatar height={50} width={50} />
        </span>
        <ul>
          {twitter && (
            <li className={styles.socialitem}>
              <SocialIcon type="x" />
              <Link
                className={styles.link}
                href={`https://twitter.com/${twitter}`}
              >
                {twitter}
              </Link>
            </li>
          )}
          {instagram && (
            <li className={styles.socialitem}>
              <SocialIcon type="instagram" />
              <Link
                className={styles.link}
                href={`https://www.instagram.com/${instagram}/`}
              >
                {instagram}
              </Link>
            </li>
          )}
          {facebook && (
            <li className={styles.socialitem}>
              <SocialIcon type="facebook" />
              <Link
                className={styles.link}
                href={`https://www.facebook.com/${facebook}`}
              >
                {facebook}
              </Link>
            </li>
          )}
          {youtube && (
            <li className={styles.socialitem}>
              <SocialIcon type="youtube" />
              <Link
                className={styles.link}
                href={`https://www.youtube.com/@${youtube}`}
              >
                {youtube}
              </Link>
            </li>
          )}
          {tiktok && (
            <li className={styles.socialitem}>
              <SocialIcon type="tiktok" />
              <Link
                className={styles.link}
                href={`https://www.tiktok.com/@${tiktok}`}
              >
                {tiktok}
              </Link>
            </li>
          )}
        </ul>
      </div>
    </SideModuleWrapper>
  );
};
